// extracted by mini-css-extract-plugin
export default {"input":"styles_input__S1Pca","input_allowance":"styles_input_allowance__3aTBW","input_price":"styles_input_price__LeSeG","desc":"styles_desc__VGXGt"};